import moment from 'moment'

export function getSurroundingWeeksRange (weeks = 0) {
  return [
    moment.utc().startOf('week').subtract(weeks, 'weeks').toDate(),
    moment.utc().endOf('week').add(weeks, 'weeks').toDate(),
  ]
}
